<div class="page">
  <div class="page-header">
    <div>
      <h1>{{ 'USERS.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'USERS.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <button type="button" class="btn btn-primary" *ngIf="permissions.canAdd('users')" (click)="onAdd()">
        <mat-icon>add</mat-icon>
        {{ 'USERS.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="card">
    <div class="table-toolbar">
      <div class="table-toolbar-left">
        <input
          type="search"
          class="search-input"
          [placeholder]="'USERS.SEARCH' | translate"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
        />
        <span class="selection-badge" *ngIf="selected.length">
          {{ selected.length }} {{ 'COMMON.SELECTED' | translate }}
        </span>
      </div>
      <div class="table-toolbar-right">
        <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length" (click)="clearSelection()">
          {{ 'COMMON.CLEAR' | translate }}
        </button>
        <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length === 1 && permissions.canEdit('users')" (click)="onEdit()">
          {{ 'COMMON.EDIT' | translate }}
        </button>
        <button type="button" class="btn btn-danger btn-sm" *ngIf="selected.length && permissions.canDelete('users')" (click)="onDeleteMany()">
          {{ 'COMMON.DELETE' | translate }}
        </button>
      </div>
    </div>

    <div class="table-scroll">
      <table class="data-table" *ngIf="paginatedUsers.length; else emptyUsers">
        <thead>
          <tr>
            <th style="width: 44px;">
              <input type="checkbox" [checked]="isAllPageSelected()" (change)="toggleSelectAll($event)" />
            </th>
            <th>{{ 'USERS.USERNAME' | translate }}</th>
            <th>{{ 'USERS.NAME' | translate }}</th>
            <th>{{ 'USERS.ROLE' | translate }}</th>
            <th>{{ 'USERS.CLASSES' | translate }}</th>
            <th>{{ 'USERS.SUBJECTS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let user of paginatedUsers"
            class="clickable"
            [class.selected]="isSelected(user)"
            (click)="openDetails(user)"
          >
            <td (click)="$event.stopPropagation()">
              <input type="checkbox" [checked]="isSelected(user)" (change)="toggleSelection(user, $event)" />
            </td>
            <td>{{ user.username }}</td>
            <td>{{ user.firstName }} {{ user.lastName }}</td>
            <td>{{ user.role?.name || '—' }}</td>
            <td>{{ formatAssignments(user.classes) }}</td>
            <td>{{ formatAssignments(user.subjects) }}</td>
          </tr>
        </tbody>
      </table>

      <ng-template #emptyUsers>
        <div class="empty-state">{{ 'USERS.EMPTY' | translate }}</div>
      </ng-template>
    </div>

    <div class="table-footer">
      <div class="paginator">
        <span>{{ 'COMMON.ROWS_PER_PAGE' | translate }}</span>
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
        </select>
        <span>{{ pageStart }}–{{ pageEnd }} {{ 'COMMON.OF' | translate }} {{ filteredUsers.length }}</span>
      </div>
      <div class="page-actions">
        <button type="button" class="btn btn-secondary btn-sm" (click)="previousPage()" [disabled]="pageIndex === 0">
          {{ 'COMMON.PREVIOUS' | translate }}
        </button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="nextPage()" [disabled]="pageIndex >= totalPages - 1">
          {{ 'COMMON.NEXT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showDeleteModal">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ deleteModalTitle | translate }}</h3>
    </div>
    <div class="modal-body">
      <p>{{ deleteModalBody | translate: deleteModalParams }}</p>
      <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onDeleteModalClose(false)">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-danger" (click)="onDeleteModalClose(true)">
        {{ 'COMMON.DELETE' | translate }}
      </button>
    </div>
  </div>
</div>

<app-users-add
  [(open)]="open"
  [(mode)]="mode"
  [(id)]="selectedIdForEdit"
  (userUpdated)="handleUserUpdated()"
></app-users-add>
